'use client'

import * as React from 'react'

import { useCarousel } from '@web/hooks/use-carousel'

interface CarouselData {
  containerRef?: React.RefObject<HTMLDivElement | null>
  nextButtonProps: CarouselButtonProps
  prevButtonProps: CarouselButtonProps
}

interface CarouselButtonProps {
  disabled: boolean
  onClick?: () => void
}

const CarouselContext = React.createContext<CarouselData>(null!)

export function CarouselContextProvider({ children }: React.PropsWithChildren) {
  const { containerRef, prevButtonProps, nextButtonProps } = useCarousel()

  return (
    <CarouselContext.Provider
      value={{
        containerRef,
        prevButtonProps,
        nextButtonProps,
      }}
    >
      {children}
    </CarouselContext.Provider>
  )
}

export const useCarouselContext = () => {
  return React.useContext(CarouselContext)
}

export const useButtonsProps = () => {
  const { prevButtonProps, nextButtonProps } = React.useContext(CarouselContext)

  return { prevButtonProps, nextButtonProps }
}
